<template>
    <div id="terms">
        <!-- #######  THIS IS A COMMENT - Visible only in the source editor #########-->
        <div class="page" title="Page 1">
            <div class="layoutArea">
            <div class="column">
                <img class="girona-logo" title="Girona FC" src="@/assets/img/logo_header.png" width="300" style="display: block; margin: 0 auto">
                <p style="text-align: center">&nbsp;</p>
                <p style="text-align: center">
                <strong>BASES LEGALS DE L&rsquo;ACTIVACIÓ:</strong>
                </p>
                <p style="text-align: center">
                <strong>&ldquo;NOU ESCUT OFICIAL DEL GIRONA FC&rdquo;</strong>
                </p>
                <p style="text-align: center">&nbsp;</p>
                <p>
                GIRONA FÚTBOL CLUB SAD (Girona FC) amb domicili social en Avinguda
                Montilivi, 141, 17003 - Girona, y CIF A-17088329, ha posat en marxa la
                següent activació &ldquo;Consulta nou escut&rdquo;, d&rsquo;acord als
                següents condicions:
                </p>
                <p>
                <b>1. VIGENCIA</b><br />
                La votació estarà activa a partir del 1 de juliol de 2021 fins al 15
                de juliol 2021.
                </p>
                <p>
                <b>2. CAPACIDAD PARA PARTICIPAR.</b><br />
                Aquesta activació està limitat a socis del Girona FC. Únicament podran
                participar aquells
                </p>
                <p>
                socis del Girona FC sense cap quota pendent i sense sancions actives.
                </p>
                <p>
                <b>3. MECÀNICA</b><br />
                El soci tindrà accés a un qüestionari que constarà de 3 fases:
                </p>
                <p>
                Primera fase. Valoració dels elements. Valora de l'1 al 10 els
                elements segons importància:
                </p>
                <ul>
                <li>
                    <p>Senyera</p>
                </li>
                <li>
                    <p>Corona</p>
                </li>
                <li>
                    <p>Llistes blanc-i-vermelles</p>
                </li>
                <li>
                    <p>Aigües</p>
                </li>
                <li>
                    <p>Bordura</p>
                </li>
                <li>
                    <p>Nom del Club</p>
                </li>
                </ul>
                    <p>
                    Segona fase. Ordenació dels elements anteriors, de més a menys
                    importants.
                    </p>
                    <p>
                    Tercera fase. Consistirà en quatre preguntes obertes.<br>
                    El soci podrà completar el qüestionari entrant en el link
                    específic a traves del microsite:

                    <a href="https://escut.gironafc.cat" target="_blank">https://escut.gironafc.cat</a><br />
                    El club tindrà en compte les valoracions i respostes dels Socis
                    per al disseny final del nou escut del Club.</p>
                <p><b>4. PROTECCIÓ DE DADES</b></p>
            </div>
            </div>
            <table>
            <tbody>
                <tr>
                <td>
                    <div class="layoutArea">
                    <div class="column">
                        <p>
                        El Girona FC informa que, mitjançant la participació en
                        aquesta activació, el participant
                        </p>
                    </div>
                    </div>
                </td>
                </tr>
                <tr>
                <td>
                    <div class="layoutArea">
                    <div class="column">
                        <p>
                        atorga el consentiment exprés en la cessió de les seves dades
                        personals únicament per al propòsit de la votació i
                        qüestionari sobre el nou escut del Club, així com per al seu
                        posterior tractament a favor del Girona FC, sense perjudici
                        dels drets que assisteixin al participant tal com: dret
                        d'accés, rectificació, supressió, limitació, portabilitat,
                        oposició ja no ser objecte de decisions individualitzades.
                        Qualsevol revocació a aquest consentiment s'haurà d'enviar un
                        correu a: protecciondatos@gironafc.cat
                        </p>
                    </div>
                    </div>
                </td>
                </tr>
            </tbody>
            </table>
        </div>
        <div class="page" title="Page 2">
            <div class="layoutArea">
            <div class="column"><br>
                <p><b>5. CONSIDERACIONS GENERALS</b></p>
            </div>
            </div>
            <table>
            <tbody>
                <tr>
                <td>
                    <div class="layoutArea">
                    <div class="column">
                        <p>
                        Ni Facebook, ni Twitter, ni Instagram patrocinen ni avalen ni
                        administren de cap manera les presents bases legals, ni estan
                        associats amb aquesta activació.
                        </p>
                        <p>
                        La simple participació en la present acció implica
                        l'acceptació íntegra de les presents bases legals, per la qual
                        cosa la manifestació en el sentit de la no acceptació de la
                        totalitat o part de les mateixes implicarà l'exclusió del
                        participant.
                        </p>
                        <p>
                        El Girona FC es reserva el dret de qualsevol canvi sobre les
                        presents bases legals, així com cancel&middot;lar, suspendre o
                        ampliar aquesta acció, que serà degudament notificat a tots
                        els participants, a través del microsite
                        <a href="https://escut.gironafc.cat" target="_blank">https://escut.gironafc.cat</a>
                        </p>
                    </div>
                    </div>
                </td>
                </tr>
                <tr>
                <td>
                    <div class="layoutArea">
                    <div class="column">
                        <p>
                        Les presents bases legals es regeixen per la llei espanyola.
                        </p>
                    </div>
                    </div>
                </td>
                </tr>
            </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
  components: {

  },
  mounted() {

  },
  methods: {

  },
};
</script>


<style>
    #terms {
        padding: 4em
    }
</style>